import { Maybe } from '@csp/csp-common-model';
import { ValueDisplayMapperOptions } from '../model/ValueDisplayMapperOptions';
import { ValueDisplay } from '../model/ValueDisplay';

const from = (
  initialValue: Maybe<string>,
  { isRequired, editablePlaceholder, secondaryValue, readOnlyPlaceholder }: ValueDisplayMapperOptions = {
    isRequired: false,
    editablePlaceholder: undefined,
    readOnlyPlaceholder: undefined,
    secondaryValue: undefined,
  },
): ValueDisplay => {
  const isMissing = !!isRequired && !initialValue;
  const isSet = !!initialValue;
  const valueOrEditablePlaceholder = initialValue || editablePlaceholder || '-';
  const valueOrReadOnlyPlaceholder = initialValue || readOnlyPlaceholder || '-';

  return {
    valueOrEditablePlaceholder,
    valueOrUndefined: initialValue || undefined,
    valueOrReadOnlyPlaceholder,
    secondaryValue,
    isRequired: !!isRequired,
    isMissing,
    isSet,
  };
};

export const ValueDisplayMapper = {
  from,
};
